import React from 'react';

const LearnServiceContext = React.createContext();

export default LearnServiceContext;